/**
 * "ver evidência" ao fim da mensagem de um achado (ADR-048, Req 6.1; design §4): leva à evidência complementar que o
 * achado cita — a ficha a abre no visualizador. Só aparece com `evidenciaId` de uma evidência da ficha.
 */

import { useVerEvidencia } from '../contexts/VerEvidenciaContext';

export function LinkVerEvidencia({ evidenciaId }: { readonly evidenciaId?: string }): JSX.Element | null {
  const ver = useVerEvidencia();
  if (!evidenciaId || !ver || !ver.ids.has(evidenciaId)) {
    return null;
  }
  return (
    <>
      {' '}
      <button type="button" className="link-btn link-evidencia" onClick={() => ver.abrir(evidenciaId)}>
        ver evidência
      </button>
    </>
  );
}
